export default {"src":"/_next/static/media/layers.6da9cc7f.svg","height":118,"width":118};